<script>
import Icon from "./Icon.vue";
export default {
  name: 'ItemStep',
  props: ['name', 'modelValue', 'data', 'disabled'],
  components: {Icon},
  data(){
    return {
    }
  }
}
</script>

<template>
  <label class="item-step">
    <input
        type="radio"
        :name="name"
        :value="data.id"
        @change="$emit('update:modelValue', data)"
        :disabled="disabled"
    >
    <div class="item-block">
      <div class="name" v-html="data.name"></div>
      <div class="arrow">
        <Icon name="arrow"/>
      </div>
    </div>
  </label>
</template>

<style lang="scss" scoped>
  @import "/src/style/variable";
  .item-step {
    $border-radius: 20px;
    display: flex;
    border-radius: $border-radius;
    background-color: $color-white;
    height: 200px;
    overflow: hidden;
    .item-block--five-items & {
      &:first-child{
        height: 440px;
        grid-column-start: 1;
        grid-row-start: 1;
        grid-row-end: 3;
        @media #{$media-767}{
          height: auto;
          min-height: 200px;
        }
      }
    }
    input {
      display: none;
      &:checked {
        &+.item-block {
          background-color: $color-blue;
          opacity: 1;
          .name {
            color: $color-white;
          }
          .arrow {
            svg {
              stroke: $color-white;
            }
          }
        }
      }
    }
    .item-block {
      display: flex;
      flex-direction: column;
      justify-content: space-between;
      width: 100%;
      border-radius: $border-radius;
      color: $color-orange;
      padding: 30px 40px;
      .item-block--selected-item & {
        opacity: 0.3;
        .name {
          color: $color-blue;
        }
      }
      .name {
        font-family: $font-family;
        font-size: 30px;
        font-weight: 600;
        font-style: normal;
        @media #{$media-575}{
          font-size: 20px;
        }
      }
      .arrow {
        display: flex;
        justify-content: right;
        svg {
          stroke: $color-blue;
        }
      }
    }

  }
</style>